export const IconSection = {
  flow: 'x',
  align: 'flex-start',
  gap: 'A',

  IconCol: {
    align: 'flex-start center',
    color: 'caption',
    SectionIcon: {
      extends: 'Icon',
      margin: 'W2 - -',
      icon: (el) => el.parent.parent.icon || 'state'
    }
  },

  Right: {
    flow: 'y',
    gap: 'A',
    flex: '1',
    minWidth: '0',

    Intro: {
      flow: 'x',
      gap: 'Z',
      align: 'baseline',
      flexWrap: 'wrap',
      childExtends: 'IntroRun',
      childrenAs: 'state',
      children: (el, s) => {
        const intro = el.parent.parent.intro
        return typeof intro === 'function' ? intro(s) : intro || []
      }
    }
  }
}

export const IntroRun = {
  tag: 'span',
  fontSize: 'A',
  color: (el, s) => s.color || 'caption',
  fontWeight: (el, s) => s.weight || '500',
  text: (el, s) => s.text
}
